"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.IconProps = exports.IconColors = exports.IconSizes = void 0;

var _colors = _interopRequireDefault(require("../colors"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _constants = require("./constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var IconSizes = {
  Tiny: 12,
  Small: 16,
  Medium: 24,
  Large: 32,
  XLarge: 48,
  XxLarge: 64,
  XxxLarge: 96,
  Huge: 128
};
exports.IconSizes = IconSizes;

var IconColors = _objectSpread({}, _colors.default, {
  CurrentColor: 'currentColor'
});

exports.IconColors = IconColors;
var IconProps = {
  size: _propTypes.default.oneOf(Object.values(IconSizes)),
  color: _propTypes.default.oneOf(Object.values(IconColors)),
  viewBox: _propTypes.default.string // eslint-disable-next-line no-unused-vars

};
exports.IconProps = IconProps;

var componentForTypeAndSize = function componentForTypeAndSize(type, size) {
  if (!_constants.componentIndex.hasOwnProperty(type)) {
    return _react.default.createElement("div", null, "Unknown icon");
  }

  var category = _constants.componentIndex[type]; // TODO(ryngonzalez): revisit using size classes
  // when we're able to pull down icons without
  // the extra padding so it isn't too small optically
  // let sizeClass = size <= IconSizes.Small ? '16' : '24'

  var sizeClass = '24';

  if (!category.hasOwnProperty(sizeClass)) {
    sizeClass = Object.keys(category)[0];
  }

  return category[sizeClass];
};

var Icon = function Icon(_ref) {
  var color = _ref.color,
      size = _ref.size,
      type = _ref.type,
      accessibilityLabel = _ref.accessibilityLabel,
      useDefaultColors = _ref.useDefaultColors,
      accessibilityDescribedBy = _ref.accessibilityDescribedBy,
      props = _objectWithoutProperties(_ref, ["color", "size", "type", "accessibilityLabel", "useDefaultColors", "accessibilityDescribedBy"]);

  return _react.default.createElement(componentForTypeAndSize(type, size), _objectSpread({
    height: size,
    width: size,
    fill: color,
    useDefaultColors: useDefaultColors,
    title: accessibilityLabel,
    'aria-describedby': accessibilityDescribedBy,
    style: {
      flexShrink: 0
    }
  }, props));
};

var Types = Object.keys(_constants.componentIndex).reduce(function (acc, key) {
  return _objectSpread({}, acc, _defineProperty({}, key, key));
}, {});
Icon.propTypes = {
  type: _propTypes.default.oneOf(Object.keys(_constants.componentIndex)).isRequired,
  size: _propTypes.default.oneOf(Object.values(IconSizes)),
  color: _propTypes.default.oneOf(Object.values(IconColors)),
  useDefaultColors: _propTypes.default.bool,
  accessibilityLabel: _propTypes.default.string,
  accessibilityDescribedBy: _propTypes.default.string
};
Icon.defaultProps = {
  type: Types.ArrowRight,
  size: IconSizes.Medium,
  color: IconColors.SystemBlack,
  useDefaultColors: false,
  accessibilityLabel: ''
};
Icon.Sizes = IconSizes;
Icon.Colors = IconColors;
Icon.Types = Types;
var _default = Icon;
exports.default = _default;